// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"119":"f5cc9acc","453":"4b4c7288","552":"2a261bc4"}[chunkId] + ".chunk.js";
};